import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import circleChecked from 'assets/icons/circle-check.svg';
import circleCrossed from 'assets/icons/circle-remove.svg';

interface NullBooleanIconProps {
  value: boolean | null;
  className?: string;
  trueAlt?: string;
  falseAlt?: string;
}

const NullBooleanIcon = ({
  value,
  className,
  trueAlt = 'trueAlt',
  falseAlt = 'falseAlt'
}: NullBooleanIconProps) => (
  <div className={classNames(className)}>
    {value === true && <img src={circleChecked} alt={trueAlt} />}
    {value === false && <img src={circleCrossed} alt={falseAlt} />}
    {_.isNull(value) && <div>-</div>}
  </div>
);

export default NullBooleanIcon;
